import { render, staticRenderFns } from "./PromoForm.vue?vue&type=template&id=6c2c1b96&"
import script from "./PromoForm.vue?vue&type=script&lang=js&"
export * from "./PromoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports